var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "18", height: "18", viewBox: "0 0 18 18", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.61 3.737l-7.475 7.474a.755.755 0 0 0-.22.534v3.203c0 .417.337.755.754.755h3.204c.2 0 .392-.08.533-.22l7.474-7.475 3.204-3.203a.755.755 0 0 0 0-1.068L13.88.534a.755.755 0 0 0-1.067 0L9.61 3.737zm.533 1.602l-.533-.534a.755.755 0 0 1 1.067-1.068l.534.534 2.136-2.136 2.135 2.136-2.135 2.135.534.534a.755.755 0 1 1-1.068 1.068l-.534-.534-6.72 6.72H3.425v-2.136l6.72-6.72z" })
  );
});